import { render } from "./SelfAssessmentV2FreeFormCalendar.vue?vue&type=template&id=1d12cd04"
import script from "./SelfAssessmentV2FreeFormCalendar.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2FreeFormCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__